/**
 * Composable for accessing Vuex store with user data
 * Provides computed properties for reading/writing user state
 */
import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Create a user store access composable
 * 
 * @returns {Object} - User store properties with getters and setters
 */
export function useUserStore() {
  const store = useStore();
  
  /**
   * User ID with getter and setter
   */
  const userId = computed({
    get: () => {
      return store.state.userId || localStorage.getItem('userId');
    },
    set: (value) => {
      store.dispatch('setUserId', value);
    }
  });
  
  /**
   * Session ID with getter and setter
   */
  const sessionId = computed({
    get: () => {
      return store.state.sessionId || localStorage.getItem('sessionId');
    },
    set: (value) => {
      store.dispatch('setSessionId', value);
    }
  });
  
  /**
   * User avatar URL with getter and setter
   */
  const userAvatarUrl = computed({
    get: () => {
      return store.state.userAvatarUrl || localStorage.getItem('userAvatarUrl');
    },
    set: (value) => {
      store.dispatch('setUserAvatarUrl', value);
    }
  });
  
  /**
   * User body ID with getter and setter
   */
  const userBodyId = computed({
    get: () => {
      return store.state.userBodyId || localStorage.getItem('userBodyId');
    },
    set: (value) => {
      store.dispatch('setUserBodyId', value);
    }
  });
  
  /**
   * Avatar gender with getter and setter
   */
  const avatarGender = computed({
    get: () => {
      return store.state.avatarGender || localStorage.getItem('avatarGender');
    },
    set: (value) => {
      store.dispatch('setAvatarGender', value);
    }
  });
  
  /**
   * Avaturn URL with getter and setter
   */
  const avaturnUrl = computed({
    get: () => {
      return store.state.avaturnUrl || localStorage.getItem('avaturnUrl');
    },
    set: (value) => {
      store.dispatch('setAvaturnUrl', value);
    }
  });
  
  return {
    userId,
    sessionId,
    userAvatarUrl,
    userBodyId,
    avatarGender,
    avaturnUrl
  };
}